import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ResponseDto } from '../dto/response.dto';

@Injectable({
    providedIn: 'root'
})
export class ErrorSubject {
    private errorSubjectInfo: BehaviorSubject<ResponseDto>;
    public errorInfo: Observable<ResponseDto>;

    constructor() {
        // Inicializamos con un objeto vacío de ResponseDto en lugar de null
        const initialErrorData: ResponseDto = {
            statusCode: '',
            response: '',
            errorDetail: '',
            httpStatus: ''
        };

        // Se inicializa con un valor por defecto o vacío
        this.errorSubjectInfo = new BehaviorSubject<ResponseDto>(initialErrorData);
        this.errorInfo = this.errorSubjectInfo.asObservable();
    }

    /**
     * Método para guardar datos del error.
     * En vez de crear un nuevo BehaviorSubject, solo emitimos el nuevo valor.
     *
     * @param data --> Datos que se guardan
     */
    saveErrorData(data: ResponseDto): void {
        console.log('Guardando datos del error:', data);
        this.errorSubjectInfo.next(data);  // Emitimos un nuevo valor
    }

    /**
     * Método para obtener los datos del error actuales.
     */
    getErrorData(): ResponseDto {
        console.log('Obteniendo los datos del error');
        return this.errorSubjectInfo.value;
    }
}
